import classes from "./Contact.module.css";
import { motion } from "framer-motion";
import { useEffect } from "react";

const Contact = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0, transition: { duration: "0.1" } }}
      className={classes.contact}
    >
      <h2 className={classes.title}>
        <span className={classes.highlight}>聯絡我們</span>
      </h2>

      <address className={classes.address}>
        <div className={classes.address__part}>
          <p>地址</p>
          <p>新北市汐止區新台五路一段79號5F-5(遠東世界中心C棟)</p>
        </div>
        <div className={classes.address__part}>
          <p>
            <a href="mailto:#">信箱</a>
          </p>
          <p>test@gmail.com</p>
        </div>
        <div className={classes.address__part}>
          <p>電話</p>
          <p>
            <a href="tel:+886-2-8698-3838">886-2-8698-3838</a>
          </p>
        </div>
        <div className={classes.address__part}>
          <p>傳真</p>
          <p>
            <a href="fax:+886-2-8698-3636">886-2-8698-3636</a>
          </p>
        </div>
      </address>
    </motion.div>
  );
};

export default Contact;
